import React from 'react';
import { useNavigate } from 'react-router-dom';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { RiEditBoxLine } from "react-icons/ri";
import { checkPermission } from '../../Utils/permissionHelper';

const EditButton = ({
    to,
    state = {},
    permission = null,
    disabled = false,
    className = "text-secondary icon-color p-0",
    tooltipTitle = "Edit",
    onClick = null
}) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        } else if (to) {
            navigate(to, { state });
        }
    };

    const isDisabled = disabled || (permission && !checkPermission(permission));

    return (
        <Tooltip
            title={tooltipTitle}
            className="btn btn-sm btn-white text-secondary insight-stickey-actions-btn"
            disabled={isDisabled}
        >
            <IconButton onClick={handleClick} disabled={isDisabled}>
                <RiEditBoxLine className={className} />
            </IconButton>
        </Tooltip>
    );
};

export default EditButton;
